import React from 'react';
import { RecommendationsCarouselsTypes } from '../../../types';
import ErrorBoundary from '../errors/error_boundary/ErrorBoundary';
import RecentlyViewedCarousel from './recently_viewed/RecentlyViewedCarousel';
import './index.scss';

const RecommendationsCarousels = ({ sorting, active, loggedIn }) => (
    <div className="recommendations-carousels">
        <ErrorBoundary>
            <RecentlyViewedCarousel sorting={sorting}
                activeFilters={active}
                loggedIn={loggedIn}/>
        </ErrorBoundary>
    </div>
);

RecommendationsCarousels.propTypes = RecommendationsCarouselsTypes;

export default RecommendationsCarousels;
